import { memo } from "react";
import { themeColors } from "@/utils/themeColors";
import { examNameToUrlComponent } from "@knowt/syncing/hooks/exams/utils";
import { SidebarBtn } from "./SidebarButtons";

const ExamCard = memo(({ name, type }: { name: string; type: string }) => {
    const examRoute = `/exams/${type}/${examNameToUrlComponent(name)}`;

    return (
        <SidebarBtn
            label={name}
            href={examRoute}
            sx={{
                border: `1px solid ${themeColors.neutral1}`,
                background: themeColors.neutralWhite,
                minHeight: "5rem",
                fontSize: "1.2rem",
                "&:hover": { boxShadow: "none", backgroundColor: themeColors.neutral1 },
            }}
        />
    );
});

ExamCard.displayName = "ExamCard";

export default ExamCard;
